<section
	class="chi-siamo"
	style="min-height: 600px"
>
	<div class="content">
		<div style="text-align: center">
			<h2 class="section-title">
				{{ "maintenance.title" | translate }}
			</h2>
			<p style="margin: 12px">
				<strong>{{ "maintenance.siteMaintenance" | translate }}</strong>
			</p>
			<p style="margin: 12px">
				<strong>{{ "maintenance.sorry" | translate }}</strong>
			</p>
			<img [src]="wcmService.maintenanceUrl" />
			<p style="margin: 12px">
				<strong>
					{{ "maintenance.contactCustomer" | translate }}
					<a
						id="customer"
						href="mailto:assistenza@clickar.com"
						><!-- TODO: Label -->Customer Center
					</a>
				</strong>
			</p>
		</div>
	</div>
</section>
